import React from 'react'
import { Box, Button } from '@mui/material'

import { AppNote } from '@components'
import { droppedText } from '../@services/leadingLink'


/** Arriving from an old Leading Analyzer link (CA 24, UX Obs. 13): where you are, the colours, what did not travel */
export default function LeadingArrivalNote({ drop = [], cuts = [], currencyCode, onClose }) {
	const dropped = droppedText(drop)
	return <AppNote severity="info">
		<b>Leading Analyzer is now part of this screen.</b> You are on its view, offices by pick-up date, with the offices, rental length and dates of your link.
		Here green means you are cheaper than the market and red dearer — Leading painted it the other way round.
		{dropped && <> {dropped}</>}
		{drop.includes('currency') && currencyCode && <> This screen uses your account currency, {currencyCode}.</>}
		{cuts.map(c => <Box key={c} component="span"> {c}</Box>)}
		<Box sx={{ mt: 1 }}><Button size="small" variant="outlined" onClick={onClose}>Got it</Button></Box>
	</AppNote>
}
